import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const AndMoreAssetLabel = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  padding: 12px 16px;
`;
